import { render } from "./GlobalNewsListSingle.vue?vue&type=template&id=771863c0"
import script from "./GlobalNewsListSingle.vue?vue&type=script&lang=js"
export * from "./GlobalNewsListSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__